<template>
  <section>
    <LoadingSpinner v-if="loading" />

    <!-- Table Contact  -->
    <button class="ml-2 btn btn-sm btn-primary" 
      @click="download()"
      :disabled="processingAllItems"
      >
      <span v-if="!processingAllItems">
        Download csv
      </span>
      <span v-else>Processing...</span>
    </button>

    <div class="mx-0 px-0 table-responsive">
      <Table
        v-if="orders.length > 0"
        class="mx-2"
        :headers="headers"
        :cols="tableCols"
        :data="orders"
        :checkbox="false"
        :notselect="true"
        :model="model"
        @openTarget="openTarget"
        @openClient="openClient"
        @goToOrder="goToOrder"
        @openSupplyDiagnostic="openSupplyDiagnostic"
        @importProgressRowUpdated="onSalesridgeImportRowUpdated"
      />


      <Modal name="target" :size="'80%'" height="500" :close="true">
        <div class="row justify-content-center p-5">
          <div class="col-md-12">
            <ContactsSituation v-if="target_id" :target_id="target_id" @getAvailableContacts="getAvailableContacts"></ContactsSituation>
          </div>
        </div>
      </Modal>

      <modal
        name="criticalSupplyDiagnostic"
        :adaptive="false"
        :resizable="true"
        :scrollable="true"
        :click-to-close="false"
        width="92%"
        height="85%"
        classes="critical-supply-diagnostic-box"
      >
        <h2
          style="z-index:99"
          @click="closeSupplyDiagnostic()"
          class="position-absolute right-0 top-0 pt-3 pr-3"
        >
          <i class="icon-close cursor-pointer"></i>
        </h2>
        <CriticalSupplyDiagnosticModal
          v-if="diagnosticTargetId"
          :target-id="diagnosticTargetId"
          @close="closeSupplyDiagnostic"
        />
      </modal>
    </div>
  </section>
</template>
<script>
import { targetsService } from "@/_services";
import { mapState } from "vuex";
import Table from "@/components/Common/Table.vue";
import TargetCampaigns from "@/components/Campaigns/TargetCampaigns.vue";
import ContactsSituation from "@/components/Targets/ContactsSituation.vue";
import CriticalSupplyDiagnosticModal from "@/components/Agencies/CriticalSupplyDiagnosticModal.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default ({

  components: {
    Table,
    TargetCampaigns,
    LoadingSpinner,
    ContactsSituation,
    CriticalSupplyDiagnosticModal,
  },

  data() {
    return {
      processingAllItems: false,
      tabs: {
        // ids from task_history, check use unique values (EmailSyncList.vue and Performances.vue)
        1: {
          id: 1,
          name: "Critical Supply",
          total: null,
        },
        2: {
          id: 2,
          name: "Low Supply",
          total: null,
        },
      },
      contactSupplyStatus: 1,
      loading: true,
      target_id: false,
      diagnosticTargetId: null,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      orders: [],
      headers: [
        {
          label: "Time",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Order id",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Expected gap",
          class: "supply-gap-col",
          size: "320px",
          percentage: "320px",
          title: "Plain-language reason the daily target is hard to reach right now",
        },
        {
          label: this.$t("lang.column.duplicate_reason"),
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.token.order_name"),
          class: "overflowhide",
          id: 1,
        },
        {
          label: '',
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.column.contact_source"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "superAdmin",
          id: 1,
        },
        {
          label: 'SR batches',
          class: "overflowhide",
          id: 1,
          title: 'SalesRidge batch import (local DB)',
        },
        {
          label: 'SalesRidge Import',
          class: "overflowhide",
          id: 1,
          title: 'Green imported · blue queued · yellow ready (API-confirmed) · gray still on SalesRidge',
        },
        // {
        //   label: 'Re-imp 24h',
        //   class: "overflowhide",
        //   id: 1,
        //   tooltip: "Lorsqu'une personne modifie un filtre cible, les contacts importés jusqu'à ce point doivent être supprimés car on ne sait plus s'ils répondent aux conditions des filtres précédents. Cela entraîne la relance du processus de recherche des contacts. Le problème avec cela est que si les filtres sont similaires et que la cible avait déjà importé, par exemple, 90 % des contacts, alors lorsqu'elle démarre la recherche à partir de zéro, elle passera beaucoup de temps à rechercher des contacts qu'elle possède déjà et qui ils ont même déjà pris contact. Cela rendra tous les processus de recherche de contacts et de consommation de clés API Apollo beaucoup moins efficaces car ils passeront beaucoup de temps à trouver des contacts qui ont déjà été contactés dans cette cible."
        // },
        // {
        //   label: 'Contct / Imprt',
        //   class: "overflowhide",
        //   id: 1,
        // },
        {
          label: 'Available contacts',
          class: "overflowhide",
          id: 1,
        },
        {
          label: 'Total imported',
          class: "overflowhide",
          id: 1,
        },
        {
          label: "3D AVG First Contact",
          class: "overflowhide",
        },
        {
          label: "Tomorrow emails",
          class: "overflowhide",
        },
        {
          label: "Diagnosis",
          class: "overflowhide text-center",
          title: "Visual supply diagnostic",
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.owner"),
          class: "overflowhide",
        },
      ],
      cols: [
        [
          {
            value: "task_open_hours",
            type: "time"
          },
        ],
        [
          {
            value: "id",
          },
        ],
        [
          {
            type: "html",
            value: "supply_context_html",
            value2: "supply_context_label",
          },
        ],
        [
          {
            value: "duplicate_reason",
            type: "html",
            class: "small"
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "openTarget",
            badges: [
              {
                badge_if: "target_status_id",
                badge_value: "4",
                badge_class: "badge badge-success text-white",
                badge_label: "Running"
              },
              {
                badge_if: "user_error",
                badge_value: "1",
                badge_class: "badge badge-danger text-white",
                badge_label: "User error"
              }
            ],
          },
        ],
        [ 
          {
            value_emit: "id",
            class: "fas fa-external-link-alt text-primary",
            type: "icon",
            type2: "emit",
            emit: "goToOrder",
          }
        ],
        [
          {
            value1: "salesridge",
            version: "version",
            format: 1,
            type: "twoValueParenthesis"
          }
        ],
        [
          {
            value: "import_batch_detail",
            value2: "import_batch_summary",
            type: "importBatchSummary",
          },
        ],
        [
          {
            type: "salesridgeImportProgress",
            value: "sr_import_progress_pct",
            value2: "sr_import_exported_batches",
            value3: "sr_import_total_batches",
            value4: "sr_import_ready_batches",
            value5: "sr_import_progress_label",
            show_enqueue_button: false,
          },
        ],
        // [
        //   {
        //     value: "already_import_24h",
        //     format: "percentage"
        //   },
        // ],
        // [
        //   {
        //     value: "percentage_used"
        //   },
        // ],
        [
          {
            value: "available_contacts"
          },
        ],
        [
          {
            value: "total_imported"
          },
        ],
        [
          {
            value: "avg_sent_3day_prc",
            badges: [
              {
                badge_if: "goingup",
                badge_value: true,
                badge_class: "badge badge-success text-white",
                badge_label: "UP"
              },
              {
                badge_if: "goingup",
                badge_value: false,
                badge_class: "badge badge-danger text-white",
                badge_label: "DOWN"
              }
            ],
          },
        ],
        [
          {
            value: "tomorrow_emails_prc",
            badges: [
              {
                badge_if: "tomorrow_goingup",
                badge_value: true,
                badge_class: "badge badge-success text-white",
                badge_label: "UP"
              },
              {
                badge_if: "tomorrow_goingup",
                badge_value: false,
                badge_class: "badge badge-danger text-white",
                badge_label: "DOWN"
              }
            ],
          },
        ],
        [
          {
            type: "icon",
            type2: "emit",
            emit: "openSupplyDiagnostic",
            value_emit: "id",
            icon_class: "icon-bar-chart text-primary",
            neutralSituationIcon: true,
          },
        ],
        [
          {
            value_label: "client",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "responsable",
          },
        ],
      ]
    }
  },

  mounted() {
    this.init()
  },

  props: {
    oliver_sale_id: {
      type: String,
      required: '0',
    }
  },

  watch: {
    oliver_sale_id(newVal, oldVal) {
      if (newVal != oldVal) {
        this.init()
      }
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isAdmin() {
      return this.user && parseInt(this.user.role_id, 10) === 1;
    },
    tableCols() {
      return this.cols.map((col) => {
        if (!col[0] || col[0].type !== "salesridgeImportProgress") {
          return col;
        }
        return [{
          ...col[0],
          show_enqueue_button: this.isAdmin,
        }];
      });
    },
  },

  methods: {

    goToOrder(order_id) {
      let url = "/orders/" + order_id.id;
      window.open(url, "_blank");
    },

    shouldExcludeFromCriticalSupply(order) {
      const avgFirstContact = parseFloat(order.avg_sent_3day) || 0;
      const tomorrowEmails = parseFloat(order.tomorrow_emails) || 0;
      return avgFirstContact > 0 && tomorrowEmails > avgFirstContact;
    },

    init() {
      if (typeof this.$route.params.item !== "undefined" && typeof this.$route.params.status !== "undefined") {
        this.contactSupplyStatus = this.$route.params.status
      }
      this.loading = true
      targetsService.getTargetContactSupply(14, 0, this.oliver_sale_id, this.contactSupplyStatus)
        .then((result) => {
          const aux = result

          let updatedOrders = aux.map(order => ({
            ...order, // Mantenemos todos los campos originales
            goingup: order.avg_sent_3day > 0 && parseFloat(order.avg_sent_3day) >= parseFloat(order.avg_sent_2day), // Agregamos el campo `goingup`
            avg_sent_3day_prc: order.new_emails_target == null || order.new_emails_target == 0 ? "0%" : parseFloat(order.avg_sent_3day / order.new_emails_target * 100).toFixed(2) + "%",
            tomorrow_goingup: order.tomorrow_emails > 0 && parseFloat(order.tomorrow_emails) > parseFloat(order.avg_sent_3day), // Agregamos el campo `goingup`
            tomorrow_emails_prc: order.new_emails_target_tm == null || order.new_emails_target_tm == 0 ? "0%" : parseFloat(order.tomorrow_emails / order.new_emails_target_tm * 100).toFixed(2) + "%",
          }));

          if (String(this.contactSupplyStatus) === '1') {
            updatedOrders = updatedOrders.filter(
              (order) => !this.shouldExcludeFromCriticalSupply(order)
            );
          }

          updatedOrders.forEach((order) => {
            order.target_id = order.id;
            order.avg_sent_3day_prc = order.avg_sent_3day + " / " + order.new_emails_target + " (" + order.avg_sent_3day_prc + ") "
            order.tomorrow_emails_prc = order.tomorrow_emails + " / " + order.new_emails_target_tm + " (" + order.tomorrow_emails_prc + ") "
            order.duplicate_reason = order.duplicate_reason + "<div class='small'>craeted: " + order.created + "</div><div class='small'>launched: " + order.launch_date + "</div>"
            order.percentage_used = order.percentage_used + "% / " + order.percentage_imported + "%"
          });

          this.orders = updatedOrders;
          this.loading = false;
          this.loadSalesridgeImportBreakdowns();
        });
    },

    onSalesridgeImportRowUpdated({ target_id, row }) {
      this.applySalesridgeImportRowUpdate(target_id, row);
    },

    applySalesridgeImportRowUpdate(targetId, row) {
      const idx = this.orders.findIndex(
        (r) => String(r.id) === String(targetId) || String(r.target_id) === String(targetId)
      );
      if (idx < 0 || !row) {
        return;
      }

      const existing = this.orders[idx];
      this.$set(this.orders, idx, {
        ...existing,
        ...row,
        id: existing.id,
        target_id: existing.id,
      });
    },

    loadSalesridgeImportBreakdowns() {
      const rows = this.orders.slice();
      let index = 0;

      const loadNext = () => {
        if (index >= rows.length) {
          return;
        }

        const row = rows[index];
        index += 1;
        const targetId = row && (row.target_id || row.id);
        if (!targetId || Number(row.sr_import_breakdown_loading) !== 1) {
          loadNext();
          return;
        }

        targetsService
          .getTargetSalesridgeImportProgressRow(targetId)
          .then((refreshed) => {
            if (refreshed) {
              this.applySalesridgeImportRowUpdate(targetId, refreshed);
            }
          })
          .catch(() => {
            const idx = this.orders.findIndex(
              (r) => String(r.id) === String(targetId)
            );
            if (idx >= 0) {
              this.$set(this.orders[idx], "sr_import_progress_label", "Could not load SalesRidge breakdown.");
              this.$set(this.orders[idx], "sr_import_breakdown_loading", 0);
            }
          })
          .finally(() => {
            loadNext();
          });
      };

      loadNext();
    },

    getAvailableContacts(data) {
      const availableContactsString = data.availableContacts.toString()
      const orderIndex = this.orders.findIndex(
        el => el.id == data.target_id
      )

      if (orderIndex !== -1) {
        this.$set(
          this.orders[orderIndex],
          'lowest_available_contacts',
          availableContactsString
        )
      }
    },

    download() {   
      this.processingAllItems = true;

      const nameDocument = this.contactSupplyStatus == '1' ? "report-critical-supply.csv" : "report-low-supply.csv";

      //Tomo headers desde simpleheader
      const headers = this.headers.map(h => h.label);

      const fields = this.tableCols.map( item => {
        const col = item[0];
        if (col.type === "importBatchSummary" && col.value2) {
          return col.value2;
        }
        if (col.type === "salesridgeImportProgress" && col.value5) {
          return col.value5;
        }
        if (col.type === "html" && col.value2) {
          return col.value2;
        }
        const value = (col.value) ? col.value : col.value_label;
        return value;
      })

      const rows = this.orders.map( item => {
        return fields.map( col => {
          return item[col];
        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.processingAllItems = false;
      },

    taskOpenHoursClass(task_open_hours) {
      if (task_open_hours < 24) {
        return "badge-warning";
      } else if (task_open_hours < 12) {
        return "badge-warning";
      }
      return "badge-danger";
    },
    openTarget(target_id) {
      this.target_id = target_id
      this.$modal.show('target');
    },
    openSupplyDiagnostic(targetId) {
      this.diagnosticTargetId = targetId;
      this.$modal.show("criticalSupplyDiagnostic", {}, {
        adaptive: false,
        width: "92%",
        height: "85%",
        classes: "critical-supply-diagnostic-box",
      });
    },
    closeSupplyDiagnostic() {
      this.$modal.hide("criticalSupplyDiagnostic");
      this.diagnosticTargetId = null;
    },
    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
  }

})
</script>
